import { Entity } from '@core/entities/entity'
import { IInspectionStatsTasks } from './IInspectionStatsTasks'
import { plainToInstance } from 'class-transformer'

export class InspectionStatsTasks extends Entity<IInspectionStatsTasks> {
  open: number
  overdue: number
  resolvedOnTimePercentage: number

  public static new(payload: unknown): InspectionStatsTasks {
    const entity = plainToInstance(InspectionStatsTasks, payload)

    return entity
  }
}
